import axios from "axios";
import { ApiKey } from "./endpoints";
import { toast } from "react-toastify";
//export const _baseURL = "http://127.0.0.1:8000"; // default to localhost if env variable is not set
//export const _baseURL = "https://localhost:44374/api";
export const _baseURL = process.env.REACT_APP_TF_BLOG_LOCAL_URL;
//export const _baseURL = "https://localhost:44374/api";

const showLoader = () => document.dispatchEvent(new Event("SHOW_LOADER"));
const hideLoader = () => document.dispatchEvent(new Event("HIDE_LOADER"));
const pageUrl = window.location.href;

// AUTHENTICATED AXIOS
export const authAxios = axios.create({
  baseURL: _baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// AUTHENTICATED AXIOS for update password

export const authAxiosForUpdatePassword = axios.create({
  baseURL: _baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// PUBLIC AXIOS
export const publicAxios = axios.create({
  baseURL: _baseURL,
  withCredentials: true,
});

//interceptor for adding token to request headers
authAxios.interceptors.request.use(async (config) => {
  let token = localStorage.getItem("token");

  // logoutUser();
  // throw new Error("Session expired");
  config.headers["Authorization"] = `Bearer ${token}`;

  return config;
});

//interceptor for adding token to request headers for update password

authAxiosForUpdatePassword.interceptors.request.use(async (config) => {
  let token = localStorage.getItem("token");

  // logoutUser();
  // throw new Error("Session expired");
  config.headers["Authorization"] = `Bearer ${token}`;

  return config;
});
export async function isloggedInFunc() {
  try {
    const res = await publicAxios.get("/auth/session");
    console.log("response", res);
    if (res?.data?.result === 1 && res?.data?.result_value === true) {
      // setIsUserLoggedIn(true);
    } else {
      logoutUser();
    }
  } catch (err) {
    // any error = not logged in
    // setIsLoggedIn(false);
  }
}

export async function refreshAccessToken() {
  try {
    const res = await publicAxios.post("/auth/refresh");

    const data = res.data?.result_value;

    if (!data?.token) {
      throw new Error("Invalid refresh response");
    }

    // Update EVERYTHING atomically
    localStorage.setItem("token", data.token);
    localStorage.setItem("tokenExpire", data.expiresAt);
    localStorage.setItem("RoleId", data.roleId);
    localStorage.setItem("username", data.username);
    localStorage.setItem("roleName", data.roleName);
    localStorage.setItem("UserId", data.userId);
    // localStorage.setItem("refreshToken", data.refreshToken);

    return data.token;
  } catch (err) {
    console.error("Refresh failed:", err);
    logoutUser();
  }
}

authAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const tokenExpired = error?.response?.headers?.["token-expired"];

    // ONLY refresh if token gets EXPIRED
    if (status === 401 && tokenExpired === "true") {
      const newToken = await refreshAccessToken();

      if (newToken) {
        error.config.headers.Authorization = `Bearer ${newToken}`;
        return authAxios(error.config); // retry original request
      }
    } else if (status === 401 || status === 403) {
      logoutUser();
      return Promise.reject(error);
    }

    return Promise.reject(error);
  },
);

// handle response for update password

authAxiosForUpdatePassword.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const tokenExpired = error?.response?.headers?.["token-expired"];

    // ONLY refresh if token gets EXPIRED
    if (status === 401 && tokenExpired === "true") {
      toast.error("Something went wrong. Please try again later.");
      logoutUser(); // logout for clear everything
      return Promise.reject(error);
    } else if (status === 401 || status === 403) {
      toast.error("Something went wrong. Please try again later.");
      logoutUser();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);

export async function logoutUser(navigate) {
  try {
    const axiosResponse = await publicAxios.post(`${ApiKey.logout}`);
    if (axiosResponse?.result_value === true) {
      localStorage.clear();
      sessionStorage.clear();
       window.location.href = "/login";
     // navigate("/login", { replace: true });
    } else {
      toast.error(axiosResponse?.error_value?.errorText);
      localStorage.clear();
      sessionStorage.clear();
       window.location.href = "/login";
     // navigate("/login", { replace: true });
    }
    console.log("Axios logout response:", axiosResponse.data);
  } catch (error) {
    console.error("Test error:", error);
  }
}
